import React, { useContext, useState, useEffect } from 'react'
import { Divider, ListItem } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import { NavLink } from 'react-router-dom'
import './Dashboard.css'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { handleRedirectInternal } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
}))

const SideNav = () => {
    const classes = useStyles()
    const history = useHistory()
    const authContext = useContext(AuthContext)

    const { user } = authContext

    const [expanded, setExpanded] = useState('')

    const handleChange = (panel) => {
        if (expanded === panel) {
            setExpanded('')
        } else {
            setExpanded(panel)
        }
    }

    useEffect(() => {
        if (location.pathname.split('/')[1]) {
            setExpanded(location.pathname.split('/')[1])
        }
    }, [location.pathname])

    return (
        <div className="sideNav">
            <div className="userAvatarProfile">
                <span className="userInitials large">
                    {user?.first_name?.charAt(0)}
                    {user?.last_name?.charAt(0)}{' '}
                </span>
                <h4>
                    {'Hello'} {user?.first_name !== 'null' ? user?.first_name : user?.companyname}
                </h4>
            </div>
            <ul>
                <ListItem button>
                    <NavLink activeClassName="active" to="/account/dashboard">
                        {'Dashboard'}
                    </NavLink>
                </ListItem>

                <ListItem button onClick={() => handleChange('account')}>
                    <div
                        className={`d-flex justify-content-between align-items-center w-100 test ${
                            expanded === 'account' && 'activeDropdown'
                        }`}
                    >
                        <span className="d-flex">
                            {/* <span className="material-icons">person</span> */}
                            {'My Account'}
                        </span>
                        {expanded === 'account' ? <ExpandLess /> : <ExpandMore />}
                    </div>
                </ListItem>

                <Collapse in={expanded === 'account'} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/account/profile">
                                {'Profile'}
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/account/change">
                                {'Change Password'}
                            </NavLink>
                        </ListItem>

                        <>
                            <ListItem button>
                                <NavLink activeClassName="active" to="/account/notifications">
                                    {'My Notifications'}
                                </NavLink>
                            </ListItem>
                        </>

                        {/* <ListItem button>
                            <NavLink
                                id="my_address"
                                activeClassName="active"
                                to="/account/myaddress"
                            >
                                {'My Address'}
                            </NavLink>
                        </ListItem> */}
                    </List>
                </Collapse>
                {false ? (
                    <>
                        <ListItem button onClick={() => handleChange('seller/auctions')}>
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'seller/auctions' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex">
                                    {/* <span className="material-icons">gavel</span> */}
                                    My Auctions
                                </span>
                                {expanded === 'seller/auctions' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>

                        <Collapse in={expanded === 'seller/auctions'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/seller/auctions/upcoming"
                                    >
                                        Upcoming
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/auctions/open">
                                        Active
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/auctions/closed">
                                        Sold
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/auctions/draft">
                                        Draft
                                    </NavLink>
                                </ListItem>
                            </List>
                        </Collapse>
                        <ListItem button onClick={() => handleChange('seller/lots')}>
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'seller/lots' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex">
                                    {/* <span className="material-icons">gavel</span> */}
                                    My Lots
                                </span>
                                {expanded === 'seller/lots' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>

                        <Collapse in={expanded === 'seller/lots'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/lots/open">
                                        Active
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/lots/sold">
                                        Sold
                                    </NavLink>
                                </ListItem>
                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/lots/unsold">
                                        Unsold
                                    </NavLink>
                                </ListItem>
                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/lots/draft">
                                        Draft
                                    </NavLink>
                                </ListItem>
                                <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/lots/relisted">
                                        Relisted
                                    </NavLink>
                                </ListItem>
                            </List>
                        </Collapse>

                        <ListItem button>
                            <NavLink activeClassName="active" to="/seller/templates">
                                {/* <span className="material-icons">table_chart</span> */}
                                Auction Templates
                            </NavLink>
                        </ListItem>

                        <ListItem button>
                            <NavLink activeClassName="active" to="/seller/product/templates">
                                {/* <span className="material-icons">table_chart</span> */}
                                Listing Templates
                            </NavLink>
                        </ListItem>

                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/seller/organization">
                                <span className="material-icons">corporate_fare</span>
                                Organization
                            </NavLink>
                        </ListItem> */}

                        <ListItem button>
                            <NavLink activeClassName="active" to="/seller/reports">
                                {/* <span className="material-icons">description</span> */}
                                Reports
                            </NavLink>
                        </ListItem>

                        {/* <ListItem button onClick={() => handleChange('payments')}>
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'payments' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex">
                                    <span className="material-icons">credit_card</span>
                                    My Payments
                                </span>
                                {expanded === 'payments' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem> */}

                        <Collapse in={expanded === 'payments'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {/* <ListItem button>
                                    <NavLink activeClassName="active" to="/payments/transactions">
                                        Transactions
                                    </NavLink>
                                </ListItem> */}

                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/seller/payments/saved_cards"
                                    >
                                        Card Details
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink
                                        activeClassName="active"
                                        to="/seller/payments/bank_details"
                                    >
                                        Bank Details
                                    </NavLink>
                                </ListItem>

                                {/* <ListItem button>
                                    <NavLink activeClassName="active" to="/seller/subscription">
                                        My Subscription
                                    </NavLink>
                                </ListItem> */}
                            </List>
                        </Collapse>
                    </>
                ) : (
                    <>
                        <ListItem button onClick={() => handleChange('auctions')}>
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'auctions' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex">
                                    {/* <span className="material-icons">gavel</span> */}
                                    {'My Bids'}
                                </span>
                                {expanded === 'auctions' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>

                        <Collapse in={expanded === 'auctions'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {/* <ListItem button>
                                    <NavLink activeClassName="active" to="/auctions/all">
                                        {'All'}
                                    </NavLink>
                                </ListItem> */}

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/auctions/winning">
                                        {'Winning'}
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/auctions/outbid">
                                        {'Currently Outbid'}
                                    </NavLink>
                                </ListItem>
                                {/* <ListItem button>
                                    <NavLink activeClassName="active" to="/auctions/won">
                                        {'Won'}
                                    </NavLink>
                                </ListItem> */}
                            </List>
                        </Collapse>

                        <ListItem button>
                            <NavLink activeClassName="active" to="/payments/emd">
                                {/* <span className="material-icons-outlined">touch_app</span> */}
                                Auction Payment History
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/invoices/all">
                                {/* <span className="material-icons-outlined">touch_app</span> */}
                                Auction Fulfilment List
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/transactions">
                                {/* <span className="material-icons-outlined">touch_app</span> */}
                                Transactions
                            </NavLink>
                        </ListItem>
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/bidderSign">
                                <span className="material-icons-outlined">touch_app</span>
                                Auction Fulfillment List
                            </NavLink>
                        </ListItem> */}
                        <ListItem button>
                            <NavLink activeClassName="active" to="/bidderSign">
                                {/* <span className="material-icons-outlined">touch_app</span> */}
                                Bidder Undertaking
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/callback">
                                {/* <span className="material-icons-outlined">touch_app</span> */}
                                Callback Requests
                            </NavLink>
                        </ListItem>
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/bidderSign">
                                <span className="material-icons-outlined">touch_app</span>
                                Demo Requests
                            </NavLink>
                        </ListItem> */}
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/bidderSign">
                                <span className="material-icons-outlined">touch_app</span>
                                Enquiry Requests
                            </NavLink>
                        </ListItem> */}
                        <ListItem button>
                            <NavLink activeClassName="active" to="/my_agreements">
                                {/* <span className="material-icons-outlined">touch_app</span> */}
                                My Agreements
                            </NavLink>
                        </ListItem>
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/bidderSign">
                                <span className="material-icons-outlined">touch_app</span>
                                Transactions
                            </NavLink>
                        </ListItem> */}
                        <ListItem button>
                            <NavLink activeClassName="active" to="/watchlist/watchlist">
                                {/* <span className="material-icons">favorite</span> */}
                                {'My Watchlist'}
                            </NavLink>
                        </ListItem>
                        {user?.admin ? (
                            <ListItem button>
                                <NavLink activeClassName="active" to="/bulkupload">
                                    {/* <span className="material-icons">favorite</span> */}
                                    {'Bulk Upload'}
                                </NavLink>
                            </ListItem>
                        ) : (
                            ''
                        )}

                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/purchases/buynow">
                                <span className="material-icons">shopping_basket</span>{' '}
                                {'My Purchases'}
                            </NavLink>
                        </ListItem>

                        <ListItem button>
                            <NavLink activeClassName="active" to="/watchlist/watchlist">
                                <span className="material-icons">favorite</span>
                                {'My Favourites'}
                            </NavLink>
                        </ListItem>

                        <ListItem button onClick={() => handleChange('payments')}>
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'payments' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex">
                                    <span className="material-icons">credit_card</span>
                                    My Payments
                                </span>
                                {expanded === 'payments' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem> */}

                        {/* <Collapse in={expanded === 'payments'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/payments/saved_cards">
                                        Card Details
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/payments/bank_details">
                                        Bank Details
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/payments/subscription">
                                        My Subscription
                                    </NavLink>
                                </ListItem>
                            </List>
                        </Collapse> */}

                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/wallet">
                                <span className="material-icons">account_balance_wallet</span>
                                My Wallet
                            </NavLink>
                        </ListItem>

                        <ListItem button>
                            <NavLink activeClassName="active" to="/transactions">
                                <span className="material-icons">swap_horizontal_circle</span>
                                My Transactions
                            </NavLink>
                        </ListItem> */}
                        {/* 
                        <ListItem button onClick={() => handleChange('invoices')}>
                            <div
                                className={`d-flex justify-content-between align-items-center w-100 test ${
                                    expanded === 'invoices' && 'activeDropdown'
                                }`}
                            >
                                <span className="d-flex">
                                    <span className="material-icons">receipt</span>
                                    My Invoices
                                </span>
                                {expanded === 'invoices' ? <ExpandLess /> : <ExpandMore />}
                            </div>
                        </ListItem>

                        <Collapse in={expanded === 'invoices'} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button>
                                    <NavLink activeClassName="active" to="/invoices/all">
                                        All
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/invoices/paid">
                                        Paid
                                    </NavLink>
                                </ListItem>

                                <ListItem button>
                                    <NavLink activeClassName="active" to="/invoices/partial">
                                        Unpaid
                                    </NavLink>
                                </ListItem>
                            </List>
                        </Collapse> */}
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/deposits/bid_deposit">
                                <span className="material-icons">how_to_vote</span> {'Deposits'}
                            </NavLink>
                        </ListItem> */}
                        {/* <ListItem button>
                            <NavLink activeClassName="active" to="/saved_search">
                                <span className="material-icons">bookmark</span> My Saved Searches
                            </NavLink>
                        </ListItem> */}
                    </>
                )}
            </ul>
        </div>
    )
}

export default SideNav
